import React from "react";
import { Deck, Slide } from "spectacle";
import createTheme from "spectacle/lib/themes/default";

const theme = createTheme({
  primary: "#F1FAEE",
  secondary: "#1D3557",
  tertiary: "#457B9D",
  quarternary: "#E63946",
  fifth: "#A8DADC",
  white: "#fff"
},
  {
    primary: { name: "Open Sans", googleFont: true, styles: ["400", "700i"] },
    secondary: "Helvetica"
  });

export default class NullDeck extends React.Component {
  render() {
    return (
      <Deck transition={["zoom", "slide"]} transitionDuration={500} theme={theme} controls={true}>
        <Slide>
          <h1>Not found</h1>
        </Slide>
      </Deck>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NullDeck.js